// The notification kinds, for the settings page and Catch Up.  tickets[9112]
//
// Mirrors api/lib/notificationKinds.ts and the CHECK constraints in migration
// 0057; the four must agree. Kept as a mirror rather than an import because the
// browser and server builds do not share source.

export const NOTIFICATION_KINDS = ["assigned", "mentioned", "due_soon", "overdue", "reminder"] as const;

export type NotificationKind = (typeof NOTIFICATION_KINDS)[number];

export type NotificationChannel = "in_app" | "email";

export const NOTIFICATION_KIND_INFO: Record<NotificationKind, { label: string; description: string }> = {
  assigned: {
    label: "Assigned to you",
    description: "A ticket is assigned to you, or lands on a team you're on.",
  },
  mentioned: {
    label: "Mentions",
    description: "Someone @mentions you in a comment.",
  },
  due_soon: {
    label: "Due soon",
    description: "A ticket assigned to you is due tomorrow. Arrives at 9am your time.",
  },
  overdue: {
    label: "Overdue",
    description: "A ticket assigned to you has passed its target date and isn't closed yet.",
  },
  reminder: {
    label: "Your reminders",
    description: "A reminder you set on a ticket comes due.",
  },
};

export interface PreferenceRow {
  kind: string;
  in_app: boolean;
  email: boolean;
}

/**
 * Whether a channel is on for a kind. No row means on: the same default
 * notification_channel_on() applies on the server.
 */
export function channelOn(prefs: readonly PreferenceRow[], kind: NotificationKind, channel: NotificationChannel) {
  const row = prefs.find((p) => p.kind === kind);
  return row ? row[channel] : true;
}
